export const TOP_NAV = 'TOP_NAV';

export type EALocation = typeof TOP_NAV;
